module.exports = __webpack_public_path__ + "img/kite.676ec112.jpeg";